import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import VueToast  from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-sugar.css'
import emailjs from '@emailjs/browser'
import JsonExcel from 'vue-json-excel'
import VueMoment from 'vue-moment'

Vue.config.productionTip = false
Vue.prototype.$http = axios;


Vue.component("downloadExcel", JsonExcel);

Vue.use(VueToast);
Vue.use(emailjs)
Vue.use(VueMoment);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
  created(){
    emailjs.init('3c3cb1a063f50238eca5adb248ca9746')
    /*this.$http.get('https://www.universal-tutorial.com/api/getaccesstoken',{
        headers : {
          "api-token": "wQrPvwCM8YkYRpYeLtpoOgQUbz-G27Gw5rYNFRZaO2OGTqzwMIIybAjIgjc3t2xPfTw",
          'Accept': 'application/json',
          "user-email": "antoniohernandezjosesantiago@gmail.com"
        }
      }).then(res=>{
        localStorage.setItem('tokens', res.data['auth_token'])
      })*/
  }
}).$mount('#app')
